import { render } from "./ModalLogin.vue?vue&type=template&id=5228f837&scoped=true"
import script from "./ModalLogin.vue?vue&type=script&lang=js"
export * from "./ModalLogin.vue?vue&type=script&lang=js"

import "./ModalLogin.vue?vue&type=style&index=0&id=5228f837&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5228f837"]])

export default __exports__